import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { RightIcon } from 'foundations-assets';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FaceNavPortalPickerMenuButton = ({
  portalId,
  portalName,
  onClick,
  onMouseEnter,
  onMouseLeave,
  isOpen
}) => {
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: isOpen ? 'fill-field-hover' : 'fill-surface-default',
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    borderColor: "border-core-default",
    id: "face-nav-portal-picker-trigger",
    children: /*#__PURE__*/_jsxs(Button, {
      "aria-label": I18n.text('learningCenter.faceNav.accessibility.portal_picker_trigger'),
      block: true,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      padding: "400",
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        flex: "1",
        gap: "100",
        justifyContent: "space-between",
        maxInlineSize: "100%",
        minInlineSize: "0",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "start",
          flex: "1",
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            marginBlockEnd: "100",
            textAlign: "start",
            typography: "heading-50",
            children: portalName
          }), /*#__PURE__*/_jsx(Text, {
            color: "text-core-subtle",
            children: portalId
          })]
        })
      }), /*#__PURE__*/_jsx(IconHolder, {
        color: "icon-core-subtle",
        icon: RightIcon,
        size: "100"
      })]
    })
  });
};